export default __webpack_public_path__ + "static/ww3-59e9be5e04add4dde618aa5fa361631b.jpg";